import React from 'react';
import { Box, Typography, Paper, Divider, Button } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { motion } from 'framer-motion';

interface AdminPlaceholderProps {
  title: string;
  description?: string;
}

const AdminPlaceholder: React.FC<AdminPlaceholderProps> = ({ 
  title, 
  description = "This section is under development. Check back soon for updates."
}) => {
  return (
    <Box sx={{ pb: 6 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Manage your {title.toLowerCase()} content displayed on the website.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Paper 
          sx={{ 
            p: 5, 
            textAlign: 'center',
            borderRadius: 2,
            backgroundColor: '#f9f9f9',
            border: '1px dashed #ccc'
          }}
        >
          <ConstructionIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          
          <Typography variant="h5" gutterBottom sx={{ color: 'text.primary', fontWeight: 'medium' }}>
            Coming Soon
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ maxWidth: '600px', mx: 'auto', mb: 4 }}>
            {description}
          </Typography>
          
          <Button 
            variant="contained" 
            color="primary"
            disabled
          >
            Feature Under Development
          </Button>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default AdminPlaceholder; 